import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Pre Employment Checks\n          ")
], -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n          For those working on HM Courts, ALL will require a specific HM Courts\n          British Standard (BPSS) Check which will include a Disclosure Check as\n          part of the British Standard.\n        ", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n          Therefore please do not select that a Disclosure Check is required\n          within the box below as this would indicate a separate Disclosure\n          Check is required.\n        ", -1);
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
import { Input } from '@/form';
export default /*#__PURE__*/ _defineComponent({
    __name: 'preEmployment',
    props: {
        formData: {},
        disableForm: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const disclosure_check = Input('Is a Disclosure Check Required?', 'disclosure_check', 'text', props.disableForm, props.formData.disclosureCheckRequired);
        const child_safegarding = Input('Is a Child Safeguarding Declaration Required?', 'child_safegarding', 'text', props.disableForm, props.formData.childSafeguardingRequired);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _hoisted_5,
                        _createTextVNode(),
                        _hoisted_6,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(disclosure_check) }, null, 8, _hoisted_7),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(child_safegarding) }, null, 8, _hoisted_8)
                    ])
                ])
            ]));
        };
    }
});
